import { render, staticRenderFns } from "./CardButton.vue?vue&type=template&id=db98b7e0&scoped=true&"
import script from "./CardButton.vue?vue&type=script&lang=ts&"
export * from "./CardButton.vue?vue&type=script&lang=ts&"
import style0 from "./CardButton.vue?vue&type=style&index=0&id=db98b7e0&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db98b7e0",
  null
  
)

export default component.exports